export const CookiesList = {
    accessToken: "accessToken",
    cookiesAccepted: "cookeisAccepted"
}

export const CookiesArray = [
    CookiesList.accessToken
]